import { Chip, useTranslations } from "@harea/component";
import { TTimeOff } from "@harea/component";

export const VacationStatus = (props: Partial<TTimeOff>) => {
    const [
        NEW,
        REFUSED,
        ACCEPTED,
        EXPIRED,
        APPROVED
    ] = useTranslations(i18n);

    if (props.status === 'validated') {
        return (
            <Chip
                label={ACCEPTED}
                type="success"
                // endIcon={"fa-circle-check text-success"}
            />
        )
    }

    if (props.status === 'approved') {
        return (
            <Chip
                label={APPROVED}
                type="success"
                // endIcon={"fa-circle-check text-link"}
            />
        )
    }

    if (props.status === 'refused') {
        return (
            <Chip
                label={REFUSED}
                type="error"
                // endIcon={"fa-circle-xmark text-danger"}
            />
        )
    }

    return (
        <Chip
            type="info"
            label={NEW}
        />
    )
}


const i18n = [
    'std_new',
    'std_refused',
    'std_validated',
    'std_expired',
    'std_approved'
];
